import { createSelector } from '@reduxjs/toolkit';
import { isEmpty, omit } from 'lodash';
import { getIsHotelOnly } from 'src/store/view/selectors';
import { getFromImmutableState } from '../../../../utils/immutableUtils';
import { getIsWhitelabel } from './view';

const _getBreadcrumbs = (state) => state.get('breadcrumbs');

export const getBreadcrumbsList = getFromImmutableState(_getBreadcrumbs);
export const getBreadcrumbs = createSelector(
  [getBreadcrumbsList, getIsWhitelabel, getIsHotelOnly],
  (items, isWhitelabel, isHotelOnly) => {
    if (isEmpty(items)) {
      return null;
    }

    if (isWhitelabel || isHotelOnly) {
      return items.map((item) => omit(item, ['link']));
    }

    return items;
  },
);
